import { RootState } from 'app/store';

export const selectUpcomingEvaluationDate = (state: RootState) =>
  state.upcomingEvaluation.upcomingEvaluationDate;
export const selectIsLoadingUpcomingEvaluation = (state: RootState) =>
  state.upcomingEvaluation.isLoadingUpcomingEvaluation;
